import React, {Component} from 'react'
import {connect} from 'react-redux'


class RoleDescription extends Component {
  constructor(props){
    super(props);
  }



  render() {
    return (
          <span className="custom-control-description">
            {this.props.label}
            <br/>
            <small>{this.props.description}</small>
          </span>
      );
    }
}

const mapStateToProps = (state, ownProps) => ({
})
const mapDispatchToProps = dispatch => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(RoleDescription)
